import _extends from "../../../../@babel/runtime/helpers/esm/extends.js";
import _objectWithoutPropertiesLoose from "../../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
import createBreakpoints from "./createBreakpoints.js";
import shape from "./shape.js";
import createSpacing from "./createSpacing.js";
import styleFunctionSx from "../styleFunctionSx/styleFunctionSx.js";
import defaultSxConfig from "../styleFunctionSx/defaultSxConfig.js";
import applyStyles from "./applyStyles.js";
import deepmerge from "../../../utils/deepmerge/deepmerge.js";
const _excluded = ["breakpoints", "palette", "spacing", "shape"];
function createTheme(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {}
  } = options, other = _objectWithoutPropertiesLoose(options, _excluded), breakpoints = createBreakpoints(breakpointsInput), spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge({
    breakpoints,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: _extends({
      mode: "light"
    }, paletteInput),
    spacing,
    shape: _extends({}, shape, shapeInput)
  }, other);
  return muiTheme.applyStyles = applyStyles, muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme), muiTheme.unstable_sxConfig = _extends({}, defaultSxConfig, other == null ? void 0 : other.unstable_sxConfig), muiTheme.unstable_sx = function(props) {
    return styleFunctionSx({
      sx: props,
      theme: this
    });
  }, muiTheme;
}
export {
  createTheme as default
};
//# sourceMappingURL=createTheme.js.map
